/* eslint-disable prettier/prettier */
import { http_mongo } from "../../configs/http-mongo";

const state = {
  listRecommends: [],
  cardFeed: {
    oAuth2Id: "",
    fullname: "",
    email: "",
    phone: "",
    dob: "",
    profiles: {
      showCommon: {
        showSexual: false,
        showGender: false,
        showAge: false,
        showHeight: false,
        showEthnicity: false,
        showChildrenPlan: false,
        showFamilyPlan: false,
        showWork: false,
        showSchool: false,
        showEducation: false,
        showDrinking: false,
        showSmoking: false,
        showDrug: false,
        showDistance: false,
      },
      interests: [],
      orientationSexuals: [],
      languages: [],
      ethnicitys: [],
      smartPhoto: false,
      favoriteSongs: [],
      gender: "",
      address: "",
      school: "",
      height: 0,
      childrenPlan: "",
      familyPlan: "",
      company: "",
      education: "",
      drinking: "",
      smoking: "",
      drug: "",
      about: "",
      zodiac: "",
      covidVaccine: "",
      personality: "",
      communicationType: "",
      loveStyle: "",
      pet: "",
      workout: "",
      dietaryPreference: "",
      socialMedia: "",
      sleepingHabit: "",
      datingPurpose: "",
      prompts: [],
      avatars: [],
    },
    settings: {
      global: {
        isEnabled: false,
        languages: [],
      },
      distancePreference: {
        range: 10,
        unit: "km",
        onlyShowInThis: false,
      },
      agePreference: {
        min: 15,
        max: 30,
        onlyShowInThis: false,
      },
      notiSeenEmail: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
      },
      notiSeenApp: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
        superLike: false,
      },
      genderFilter: "all",
      autoPlayVideo: "always",
      showTopPick: true,
      showOnlineStatus: true,
      showActiveStatus: true,
      incognitoMode: true,
    },
    verifyStatus: false,
    activeStatus: false,
    location: {
      lat: "",
      long: "",
    },
    coins: 0,
    explore: {
      verified: false,
      topics: [],
    },
    plusCtrl: {
      whoYouSee: "default",
      whoSeeYou: "everyone",
    },
    numberLike: 0,
    numberSuperLike: 0,
    numberBooster: 0,
  },

  userMatch: {
    oAuth2Id: "",
    fullname: "",
    email: "",
    phone: "",
    dob: "",
    profiles: {
      showCommon: {
        showSexual: false,
        showGender: false,
        showAge: false,
        showHeight: false,
        showEthnicity: false,
        showChildrenPlan: false,
        showFamilyPlan: false,
        showWork: false,
        showSchool: false,
        showEducation: false,
        showDrinking: false,
        showSmoking: false,
        showDrug: false,
        showDistance: false,
      },
      interests: [],
      orientationSexuals: [],
      languages: [],
      ethnicitys: [],
      smartPhoto: false,
      favoriteSongs: [],
      gender: "",
      address: "",
      school: "",
      height: 0,
      childrenPlan: "",
      familyPlan: "",
      company: "",
      education: "",
      drinking: "",
      smoking: "",
      drug: "",
      about: "",
      zodiac: "",
      covidVaccine: "",
      personality: "",
      communicationType: "",
      loveStyle: "",
      pet: "",
      workout: "",
      dietaryPreference: "",
      socialMedia: "",
      sleepingHabit: "",
      datingPurpose: "",
      prompts: [],
      avatars: [],
    },
    settings: {
      global: {
        isEnabled: false,
        languages: [],
      },
      distancePreference: {
        range: 10,
        unit: "km",
        onlyShowInThis: false,
      },
      agePreference: {
        min: 15,
        max: 30,
        onlyShowInThis: false,
      },
      notiSeenEmail: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
      },
      notiSeenApp: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
        superLike: false,
      },
      genderFilter: "all",
      autoPlayVideo: "always",
      showTopPick: true,
      showOnlineStatus: true,
      showActiveStatus: true,
      incognitoMode: true,
    },
    verifyStatus: false,
    activeStatus: false,
    location: {
      lat: "",
      long: "",
    },
    coins: 0,
    explore: {
      verified: false,
      topics: [],
    },
    plusCtrl: {
      whoYouSee: "default",
      whoSeeYou: "everyone",
    },
    numberLike: 0,
    numberSuperLike: 0,
    numberBooster: 0,
  },

  statusUpdate: "",
  indexValue: 0,
  avatarChecked: [],

  modelUser: {
    oAuth2Id: "",
    fullname: "",
    email: "",
    phone: "",
    dob: "",
    profiles: {
      showCommon: {
        showSexual: false,
        showGender: false,
        showAge: false,
        showHeight: false,
        showEthnicity: false,
        showChildrenPlan: false,
        showFamilyPlan: false,
        showWork: false,
        showSchool: false,
        showEducation: false,
        showDrinking: false,
        showSmoking: false,
        showDrug: false,
        showDistance: false,
      },
      interests: [],
      orientationSexuals: [],
      languages: [],
      ethnicitys: [],
      smartPhoto: false,
      favoriteSongs: [],
      gender: "",
      address: "",
      school: "",
      height: 0,
      childrenPlan: "",
      familyPlan: "",
      company: "",
      education: "",
      drinking: "",
      smoking: "",
      drug: "",
      about: "",
      zodiac: "",
      covidVaccine: "",
      personality: "",
      communicationType: "",
      loveStyle: "",
      pet: "",
      workout: "",
      dietaryPreference: "",
      socialMedia: "",
      sleepingHabit: "",
      datingPurpose: "",
      prompts: [],
      avatars: [],
    },
    settings: {
      global: {
        isEnabled: false,
        languages: [],
      },
      distancePreference: {
        range: 10,
        unit: "km",
        onlyShowInThis: false,
      },
      agePreference: {
        min: 15,
        max: 30,
        onlyShowInThis: false,
      },
      notiSeenEmail: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
      },
      notiSeenApp: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
        superLike: false,
      },
      genderFilter: "all",
      autoPlayVideo: "always",
      showTopPick: true,
      showOnlineStatus: true,
      showActiveStatus: true,
      incognitoMode: true,
    },
    verifyStatus: false,
    activeStatus: false,
    location: {
      lat: "",
      long: "",
    },
    coins: 0,
    explore: {
      verified: false,
      topics: [],
    },
    plusCtrl: {
      whoYouSee: "default",
      whoSeeYou: "everyone",
    },
    numberLike: 0,
    numberSuperLike: 0,
    numberBooster: 0,
  },

  userAdmin: {
    oAuth2Id: "",
    fullname: "",
    email: "",
    phone: "",
    dob: "",
    profiles: {
      showCommon: {
        showSexual: false,
        showGender: false,
        showAge: false,
        showHeight: false,
        showEthnicity: false,
        showChildrenPlan: false,
        showFamilyPlan: false,
        showWork: false,
        showSchool: false,
        showEducation: false,
        showDrinking: false,
        showSmoking: false,
        showDrug: false,
        showDistance: false,
      },
      interests: [],
      orientationSexuals: [],
      languages: [],
      ethnicitys: [],
      smartPhoto: false,
      favoriteSongs: [],
      gender: "",
      address: "",
      school: "",
      height: 0,
      childrenPlan: "",
      familyPlan: "",
      company: "",
      education: "",
      drinking: "",
      smoking: "",
      drug: "",
      about: "",
      zodiac: "",
      covidVaccine: "",
      personality: "",
      communicationType: "",
      loveStyle: "",
      pet: "",
      workout: "",
      dietaryPreference: "",
      socialMedia: "",
      sleepingHabit: "",
      datingPurpose: "",
      prompts: [],
      avatars: [],
    },
    settings: {
      global: {
        isEnabled: false,
        languages: [],
      },
      distancePreference: {
        range: 10,
        unit: "km",
        onlyShowInThis: false,
      },
      agePreference: {
        min: 15,
        max: 30,
        onlyShowInThis: false,
      },
      notiSeenEmail: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
      },
      notiSeenApp: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
        superLike: false,
      },
      genderFilter: "all",
      autoPlayVideo: "always",
      showTopPick: true,
      showOnlineStatus: true,
      showActiveStatus: true,
      incognitoMode: true,
    },
    verifyStatus: false,
    activeStatus: false,
    location: {
      lat: "21.027763",
      long: "105.834160",
    },
    coins: 0,
    explore: {
      verified: false,
      topics: [],
    },
    plusCtrl: {
      whoYouSee: "default",
      whoSeeYou: "everyone",
    },
    numberLike: 0,
    numberSuperLike: 0,
    numberBooster: 0,
  },
  userFriend: {
    oAuth2Id: "",
    fullname: "",
    email: "",
    phone: "",
    dob: "",
    profiles: {
      showCommon: {
        showSexual: false,
        showGender: false,
        showAge: false,
        showHeight: false,
        showEthnicity: false,
        showChildrenPlan: false,
        showFamilyPlan: false,
        showWork: false,
        showSchool: false,
        showEducation: false,
        showDrinking: false,
        showSmoking: false,
        showDrug: false,
        showDistance: false,
      },
      interests: [],
      orientationSexuals: [],
      languages: [],
      ethnicitys: [],
      smartPhoto: false,
      favoriteSongs: [],
      gender: "",
      address: "",
      school: "",
      height: 0,
      childrenPlan: "",
      familyPlan: "",
      company: "",
      education: "",
      drinking: "",
      smoking: "",
      drug: "",
      about: "",
      zodiac: "",
      covidVaccine: "",
      personality: "",
      communicationType: "",
      loveStyle: "",
      pet: "",
      workout: "",
      dietaryPreference: "",
      socialMedia: "",
      sleepingHabit: "",
      datingPurpose: "",
      prompts: [],
      avatars: [],
    },
    settings: {
      global: {
        isEnabled: false,
        languages: [],
      },
      distancePreference: {
        range: 10,
        unit: "km",
        onlyShowInThis: false,
      },
      agePreference: {
        min: 15,
        max: 30,
        onlyShowInThis: false,
      },
      notiSeenEmail: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
      },
      notiSeenApp: {
        newMatchs: false,
        incomingMessage: false,
        promotions: false,
        superLike: false,
      },
      genderFilter: "all",
      autoPlayVideo: "always",
      showTopPick: true,
      showOnlineStatus: true,
      showActiveStatus: true,
      incognitoMode: true,
    },
    verifyStatus: false,
    activeStatus: false,
    location: {
      lat: "21.027763",
      long: "105.834160",
    },
    coins: 0,
    explore: {
      verified: false,
      topics: [],
    },
    plusCtrl: {
      whoYouSee: "default",
      whoSeeYou: "everyone",
    },
    numberLike: 0,
    numberSuperLike: 0,
    numberBooster: 0,
  },

  listPromptDefault: [
    {
      id: "prompt_1",
      name: "Select a Prompt",
      code: "",
      answer: "And write your own answer",
      status: 0, // 0: default, 1: add, 2: delete
    },
    {
      id: "prompt_2",
      name: "Select a Prompt",
      code: "",
      answer: "And write your own answer",
      status: 0,
    },
    {
      id: "prompt_3",
      name: "Select a Prompt",
      code: "",
      answer: "And write your own answer",
      status: 0,
    },
  ],

  lifeStyleSingle: {
    datingPurpose: {},
    languages: [],
    interests: [],
    schools: [],
    orientationSexuals: [],
    ethnicitys: [],
  },

  basicInformation: {
    zodiac: "",
    familyPlan: "",
    education: "",
    personality: "",
    covidVaccine: "",
    communicationType: "",
    loveStyle: "",
  },

  styleOfLife: {
    pet: "",
    drinking: "",
    smoking: "",
    workout: "",
    dietaryPreference: "",
    socialMedia: "",
    sleepingHabit: "",
  },

  listLanguageGlobal: [],
};

const getters = {};

const mutations = {
  setInformationUserMatch(state, data) {
    state.userMatch = data;
  },
  setInformationUserAdmin(state, data) {
    debugger;
    state.userAdmin = data;
  },

  setInformationUserFriend(state, data) {
    state.userFriend = data;
  },

  setListRecommends(state, data) {
    debugger;

    state.listRecommends = data;
    if (data[0] === undefined) {
      state.cardFeed = {};
    } else {
      debugger;
      state.cardFeed = data[0];
    }
  },
  setObjectRecommends(state, val) {
    debugger;
    if (val === true) {
      state.indexValue = state.indexValue + 1;
      state.cardFeed = state.listRecommends[state.indexValue];
    } else {
      state.indexValue = state.indexValue - 1;
      state.cardFeed = state.listRecommends[state.indexValue];
    }
  },
  setUpdateProfile(state, data) {
    state.statusUpdate = data;
  },

  // Set detail user
  setDetailInformationUser(state, data) {
    debugger;
    state.modelUser = {
      ...state.modelUser,
      ...data,
      profiles: {
        ...state.modelUser.profiles,
        ...data.profiles,
      },
      settings: {
        ...state.modelUser.settings,
        ...data.settings,
      },
      explore: {
        ...state.modelUser.explore,
        ...data.explore,
      },
    };
    state.lifeStyleSingle.datingPurpose = {};
    state.lifeStyleSingle.languages = [];

    state.lifeStyleSingle.interests = [];
    state.lifeStyleSingle.schools = [];
    state.lifeStyleSingle.orientationSexuals = [];
    // interest

    for (let index = 0; index < data.profiles.interests.length; index++) {
      const element = data.profiles.interests[index];
      const findInterest =
        this.state.commonModule.listLifeStyleCommons.interests.find(
          (x) => x.code === element
        );

      if (findInterest) {
        state.lifeStyleSingle.interests.push(findInterest.value);
      }
    }
    // Dating Purpose
    const findDatingPurpose =
      this.state.commonModule.listLifeStyleCommons.datingPurposes.find(
        (x) => x.code === data.profiles.datingPurpose
      );
    if (findDatingPurpose) {
      state.lifeStyleSingle.datingPurpose = findDatingPurpose;
    }

    // Languages
    for (let index = 0; index < data.profiles.languages.length; index++) {
      const element = data.profiles.languages[index];

      const findLanguages =
        this.state.commonModule.listLifeStyleCommons.languages.find(
          (x) => x.code === element
        );

      if (findLanguages) {
        state.lifeStyleSingle.languages.push(findLanguages.value);
      }
    }

    // orientation sexual
    for (
      let index = 0;
      index < data.profiles.orientationSexuals.length;
      index++
    ) {
      const element = data.profiles.orientationSexuals[index];
      const findSexual =
        this.state.commonModule.listLifeStyleCommons.sexuals.find(
          (x) => x.code === element
        );

      if (findSexual) {
        state.lifeStyleSingle.orientationSexuals.push(findSexual.value);
      }
    }

    // Basic information

    const findZodiac =
      this.state.commonModule.listInformationBasic.zodiacs.find(
        (x) => x.code === data.profiles.zodiac
      );
    const findEducation =
      this.state.commonModule.listInformationBasic.educations.find(
        (x) => x.code === data.profiles.education
      );
    const findFamilyPlans =
      this.state.commonModule.listInformationBasic.familyPlans.find(
        (x) => x.code === data.profiles.personality
      );
    const findCovidVaccines =
      this.state.commonModule.listInformationBasic.covidVaccines.find(
        (x) => x.code === data.profiles.covidVaccine
      );
    const findPersonalities =
      this.state.commonModule.listInformationBasic.personalities.find(
        (x) => x.code === data.profiles.personality
      );
    const findCommunicationStyles =
      this.state.commonModule.listInformationBasic.communicationStyles.find(
        (x) => x.code === data.profiles.communicationType
      );
    const findLoveStyles =
      this.state.commonModule.listInformationBasic.loveStyles.find(
        (x) => x.code === data.profiles.loveStyle
      );
    if (findZodiac) {
      state.basicInformation.zodiac = findZodiac.value;
    }
    if (findEducation) {
      state.basicInformation.education = findEducation.value;
    }
    if (findFamilyPlans) {
      state.basicInformation.familyPlan = findFamilyPlans.value;
    }
    if (findCovidVaccines) {
      state.basicInformation.covidVaccine = findCovidVaccines.value;
    }
    if (findPersonalities) {
      state.basicInformation.personality = findPersonalities.value;
    }
    if (findCommunicationStyles) {
      state.basicInformation.communicationType = findCommunicationStyles.value;
    }
    if (findLoveStyles) {
      state.basicInformation.loveStyle = findLoveStyles.value;
    }

    // Life of style
    const findPets = this.state.commonModule.listLifeStyleStatic.pets.find(
      (x) => x.code === data.profiles.pet
    );
    const findDrink =
      this.state.commonModule.listLifeStyleStatic.drinkings.find(
        (x) => x.code === data.profiles.drinking
      );
    const findFoodPreferences =
      this.state.commonModule.listLifeStyleStatic.foodPreferences.find(
        (x) => x.code === data.profiles.dietaryPreference
      );
    const findSleepingStyles =
      this.state.commonModule.listLifeStyleStatic.sleepingStyles.find(
        (x) => x.code === data.profiles.sleepingHabit
      );
    const findSmokings =
      this.state.commonModule.listLifeStyleStatic.smokings.find(
        (x) => x.code === data.profiles.smoking
      );
    const findSocials =
      this.state.commonModule.listLifeStyleStatic.socials.find(
        (x) => x.code === data.profiles.socialMedia
      );
    const findWorkouts =
      this.state.commonModule.listLifeStyleStatic.workouts.find(
        (x) => x.code === data.profiles.workout
      );

    if (findPets) {
      state.styleOfLife.pet = findPets.value;
    }
    if (findDrink) {
      state.styleOfLife.drinking = findDrink.value;
    }
    if (findFoodPreferences) {
      state.styleOfLife.dietaryPreference = findFoodPreferences.value;
    }
    if (findSleepingStyles) {
      state.styleOfLife.sleepingHabit = findSleepingStyles.value;
    }
    if (findSmokings) {
      state.styleOfLife.smoking = findSmokings.value;
    }

    if (findSocials) {
      state.styleOfLife.socialMedia = findSocials.value;
    }
    if (findWorkouts) {
      state.styleOfLife.workout = findWorkouts.value;
    }
  },

  // Profile

  // Xét image crop
  setNewImageCrop(state, value) {
    debugger;
    const indexImage = state.avatarChecked.length;

    const findData = state.modelUser.profiles.avatars[value.idUrl];

    if (findData) {
      state.modelUser.profiles.avatars.splice(value.idUrl, 1);
    }
    const objectImage = {
      id: indexImage,
      url: value.listImage.url,
    };
    state.modelUser.profiles.avatars.push({
      meta: value.listImage,
    });
  },

  setPhotoEdit(state, index) {
    state.modelUser.profiles.avatars.splice(index, 1);
  },
  // Xét Smart-photo
  setShowSmartPhoto(state, data) {
    state.modelUser.profiles.smartPhoto = data;
  },

  /**
   * Xét about
   * @param {*} state
   * @param {*} data
   */
  setValueAbout(state, data) {
    state.modelUser.profiles.about = data;
  },

  setValuePrompt(state, data) {
    debugger;

    // if (state.modelUser.profiles.prompts.length < 3) {
    //   state.modelUser.profiles.prompts.push(data);
    // }

    const promptList = state.modelUser.profiles.prompts;
    const item = promptList[data.idPrompt.split("_")[1]];
    if (item) {
      item.id = data.id;
      item.codePrompt = data.codePrompt;
      item.answer = data.answer;
      item.order = data.order;
    } else {
      state.modelUser.profiles.prompts.push(data);
    }

    // state.modelUser.profiles.prompts.map((item, index) => {
    //   if (parseInt(data.idPrompt.split("_")[1]) === index) {
    //     debugger;
    //     if (item.id !== "") {
    //       item.id = data.id;
    //       item.codePrompt = data.codePrompt;
    //       item.answer = data.answer;
    //       item.order = data.order;
    //     } else {
    //       state.modelUser.profiles.prompts.push(data);
    //     }
    //   }
    // });
  },

  setValuePromptAnswer(state, index) {
    debugger;
    state.modelUser.profiles.prompts.splice(index, 1);
    state.listPromptDefault.splice(index, 1);

    let objectDefault = {
      id: "prompt_" + index,
      name: "Select a Prompt",
      code: "",
      answer: "And write your own answer",
      status: 0,
    };

    let objectPrompts = {
      id: "",
      answer: "",
      codePrompt: "",
    };
    state.modelUser.profiles.prompts.splice(index, 0, objectPrompts);

    state.listPromptDefault.splice(index, 0, objectDefault);
  },

  /**
   * Xét interest
   * @param {*} state
   * @param {*} data
   */
  setValueInterests(state, data) {
    let newInterestCode = [];
    let newInterestValue = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      newInterestCode.push(element.code);
      newInterestValue.push(element.value);
    }
    state.lifeStyleSingle.interests = newInterestValue;
    state.modelUser.profiles.interests = newInterestCode;
  },

  /**
   * Xét dating purpose
   * @param {*} state
   * @param {*} data
   */
  setValueDatingPurposes(state, data) {
    state.lifeStyleSingle.datingPurpose = data;
    state.modelUser.profiles.datingPurpose = data.code;
  },

  /**
   * Xét languages
   * @param {*} state
   * @param {*} data
   */
  setValueLanguages(state, data) {
    let newDataCode = [];
    let newDataValue = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      newDataCode.push(element.code);
      newDataValue.push(element.value);
    }

    state.modelUser.profiles.languages = newDataCode;
    state.lifeStyleSingle.languages = newDataValue;
  },

  /**
   * Xét zodiac
   * @param {*} state
   * @param {*} value
   */
  setValueZodiac(state, value) {
    state.basicInformation.zodiac = value.value;
    state.modelUser.profiles.zodiac = value.code;
  },

  /**
   * Xét education
   * @param {*} state
   * @param {*} value
   */
  setValueEducation(state, value) {
    state.basicInformation.education = value.value;
    state.modelUser.profiles.education = value.code;
  },

  /**
   * Xét personality
   * @param {*} state
   * @param {*} value
   */
  setValuePersonality(state, value) {
    state.basicInformation.personality = value.value;
    state.modelUser.profiles.personality = value.code;
  },

  /**
   * Xét Covid Vaccines
   * @param {*} state
   * @param {*} value
   */
  setValueCovidVaccines(state, value) {
    state.basicInformation.covidVaccine = value.value;
    state.modelUser.profiles.covidVaccine = value.code;
  },

  /**
   * Xét Family Plan
   * @param {*} state
   * @param {*} value
   */
  setValueFamilyPlan(state, value) {
    state.basicInformation.familyPlan = value.value;
    state.modelUser.profiles.familyPlan = value.code;
  },

  /**
   * Xét Communication
   * @param {*} state
   * @param {*} value
   */
  setValueCommunication(state, value) {
    state.basicInformation.communicationType = value.value;
    state.modelUser.profiles.communicationType = value.code;
  },

  /**
   * Xét Love style
   * @param {*} state
   * @param {*} value
   */
  setValueLoveStyles(state, value) {
    state.basicInformation.loveStyle = value.value;
    state.modelUser.profiles.loveStyle = value.code;
  },

  /**
   * Xét Pets
   * @param {*} state
   * @param {*} value
   */
  setValuePets(state, value) {
    state.styleOfLife.pet = value.value;
    state.modelUser.profiles.pet = value.code;
  },

  /**
   * Xét Drinking
   * @param {*} state
   * @param {*} value
   */
  setValueDrinking(state, value) {
    state.styleOfLife.drinking = value.value;
    state.modelUser.profiles.drinking = value.code;
  },

  /**
   * Xét smoking
   * @param {*} state
   * @param {*} value
   */
  setValueSmoking(state, value) {
    state.styleOfLife.smoking = value.value;
    state.modelUser.profiles.smoking = value.code;
  },

  /**
   * Xét workout
   * @param {*} state
   * @param {*} value
   */
  setValueWorkout(state, value) {
    state.styleOfLife.workout = value.value;
    state.modelUser.profiles.workout = value.code;
  },

  /**
   * xét DietaryPreference
   * @param {*} state
   * @param {*} value
   */
  setValueDietaryPreference(state, value) {
    state.styleOfLife.dietaryPreference = value.value;
    state.modelUser.profiles.dietaryPreference = value.code;
  },

  /**
   * Xét Social Media
   * @param {*} state
   * @param {*} value
   */
  setValueSocialMedia(state, value) {
    state.styleOfLife.socialMedia = value.value;
    state.modelUser.profiles.socialMedia = value.code;
  },

  /**
   * Xét Sleeping Habit
   * @param {*} state
   * @param {*} value
   */
  setValueSleepingHabit(state, value) {
    state.styleOfLife.sleepingHabit = value.value;
    state.modelUser.profiles.sleepingHabit = value.code;
  },

  /**
   * Xét job title
   * @param {*} state
   * @param {*} value
   */
  setValueJobTitle(state, value) {
    state.modelUser.profiles.jobTitle = value;
  },

  setValueCompany(state, value) {
    state.modelUser.profiles.company = value;
  },

  setShowHeight(state, data) {
    state.modelUser.profiles.showCommon.showHeight = data;
  },

  setValueHeight(state, data) {
    state.modelUser.profiles.height = data;
  },

  setValueChildrenPlan(state, data) {
    state.modelUser.profiles.childrenPlan = data;
  },

  setShowChildrenPlan(state, data) {
    state.modelUser.profiles.showCommon.showChildrenPlan = data;
  },

  setValueDrug(state, data) {
    state.modelUser.profiles.drug = data;
  },

  setShowDrug(state, data) {
    state.modelUser.profiles.showCommon.showDrug = data;
  },

  setValueEthnicity(state, data) {
    let newDataCode = [];
    let newDataValue = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      newDataCode.push(element.code);
      newDataValue.push(element.value);
    }

    state.modelUser.profiles.ethnicitys = newDataCode;
    state.lifeStyleSingle.ethnicitys = newDataValue;
  },

  setShowEthnicity(state, data) {
    state.modelUser.profiles.showCommon.showEthnicity = data;
  },

  setValueSchool(state, value) {
    debugger;
    state.modelUser.profiles.school = value;
  },

  setValueAddressLocation(state, data) {
    state.modelUser.profiles.address = data;
  },

  setValueGender(state, gender) {
    state.modelUser.profiles.gender = gender;
  },

  setValueSexuals(state, sexuals) {
    const index = state.modelUser.profiles.orientationSexuals.indexOf(sexuals);
    if (index > -1) {
      // only splice array when item is found
      state.modelUser.profiles.orientationSexuals.splice(index, 1);
      state.isCheckBox = false;
      // 2nd parameter means remove one item only
    } else {
      if (state.modelUser.profiles.orientationSexuals.length < 3) {
        state.modelUser.profiles.orientationSexuals.push(sexuals);
      } else {
        state.isCheckBox = true;
      }
    }
  },

  setValueListSexuals(state, data) {
    let newSexualCode = [];
    let newSexualValue = [];

    for (let index = 0; index < data.length; index++) {
      const element = data[index];

      newSexualCode.push(element.code);
      newSexualValue.push(element.value);
    }
    state.lifeStyleSingle.orientationSexuals = newSexualValue;
    state.modelUser.profiles.orientationSexuals = newSexualCode;
  },

  setShowValueDistance(state, value) {
    state.modelUser.profiles.showCommon.showDistance = value;
  },

  setShowValueAge(state, value) {
    state.modelUser.profiles.showCommon.showAge = value;
  },
  setShowValueEducation(state, value) {
    state.modelUser.profiles.showCommon.showEducation = value;
  },
  setShowValueFamily(state, value) {
    state.modelUser.profiles.showCommon.showFamilyPlan = value;
  },

  setUpdatePromptAnswer(state, data) {},

  setValueDistance(state, value) {
    state.modelUser.settings.distancePreference.range = value;
  },
  setPeopleDistance(state, value) {
    state.modelUser.settings.distancePreference.onlyShowInThis = value;
  },

  setAgePreference(state, value) {
    state.modelUser.settings.agePreference.onlyShowInThis = value;
  },
  setValueAgeRange(state, value) {
    state.modelUser.settings.agePreference.min = value[0];
    state.modelUser.settings.agePreference.max = value[1];
  },

  setShowGender(state, showGender) {
    state.modelUser.settings.genderFilter = showGender;
  },

  setAutoPlayVideo(state, value) {
    state.modelUser.settings.autoPlayVideo = value;
  },

  setShowTopPicks(state, value) {
    state.modelUser.settings.toppicksDiscoverable = value;
  },

  setActivityStatus(state, value) {
    state.modelUser.settings.showActiveStatus = value;
  },

  setShowGlobal(state, value) {
    if (!value.isEnabled) {
      state.listLanguageGlobal = state.modelUser.settings.global.languages;
    }
    state.modelUser.settings.global.isEnabled = value.isEnabled;
    state.modelUser.settings.global.languages = value.languages;
  },

  setShowDistanceUnit(state, value) {
    state.modelUser.settings.distancePreference.unit = value;

    localStorage.setItem("unit", value);
  },
};

const actions = {
  /**
   * Lấy danh sách Recommends
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async getListRecommends({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(
          `api/v1/cards/recommends?pageSize=${data.pageSize}&currentPage=${data.currentPage}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            commit("setListRecommends", response.data.data);
            resolve(response.data.data);
          } else {
            reject("Error: API returned non-200 status");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Cập nhật thông tin
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async updateProfileUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      debugger;
      http_mongo
        .post(`api/v1/profile`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setUpdateProfile", response.data.data);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Cập nhật setting
   * @param {*} param0
   * @param {*} data
   */
  async updateSettingUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`api/v1/setting`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setUpdateProfile", response.data.data);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Lấy chi tiết thông tin user
   * @param {*} param0
   * @returns
   */
  async getDetailUser({ commit }) {
    return new Promise((resolve, reject) => {
      http_mongo
        .get(`api/v1/profile`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setDetailInformationUser", response.data.data);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * UPdate prompt answers
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async updatePromptAnswer({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .post(`api/v1/profile/prompts`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setUpdatePromptAnswer", response.data.data);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete prompt answers
   * @param {*} param0
   * @param {*} data
   * @returns
   */
  async deletePromptAnswer({ commit }, data) {
    return new Promise((resolve, reject) => {
      http_mongo
        .delete(`api/v1/profile/prompts`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenIdV2")}`,
          },
          data: data,
        })
        .then((response) => {
          if (response.status === 200) {
            commit("setDeletePromptAnswer", response.data.data);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
